/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_item = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpRespHeroCarouselRequestMoreImages_item";
};
export type PdpRespHeroCarouselRequestMoreImages_item$data = PdpRespHeroCarouselRequestMoreImages_item;
export type PdpRespHeroCarouselRequestMoreImages_item$key = {
    readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselRequestMoreImages_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '092c74d315099a40ad4b44ee46353114';
export default node;
